import React from 'react';
import { FormGroup, Grid, FormControlLabel, Checkbox } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useEvents } from 'hooks';

const EventDetailsSwitch = () => {
  const { t } = useTranslation();
  const { showEventDetails, setShowEventDetails } = useEvents();

  const toggleDetails = (event) => {
    setShowEventDetails(event.target.checked);
  };

  return (
    <FormGroup>
      <Grid container item>
        <FormControlLabel
          control={<Checkbox color="primary" checked={showEventDetails} size="small" onChange={toggleDetails} />}
          label={t('event_detail_view')}
          labelPlacement="end"
        />
      </Grid>
    </FormGroup>
  );
};

export default EventDetailsSwitch;
